module.exports = __webpack_public_path__ + "img/gongxinbu.1c933acf.jpeg";